// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__eiXM_"};